var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 10.2008C12.2154 10.2008 13.2004 9.21581 13.2004 8.00078C13.2004 6.78576 12.2154 5.80078 11.0004 5.80078C9.78535 5.80078 8.80038 6.78576 8.80038 8.00078C8.80038 9.21581 9.78535 10.2008 11.0004 10.2008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.503906 8.00082C1.90558 3.53798 6.07492 0.300781 11.0003 0.300781C15.9257 0.300781 20.095 3.53795 21.4967 8.00074C20.0951 12.4636 15.9257 15.7008 11.0003 15.7008C6.07492 15.7008 1.90561 12.4636 0.503906 8.00082ZM15.4004 8.00078C15.4004 10.4308 13.4304 12.4008 11.0004 12.4008C8.57032 12.4008 6.60038 10.4308 6.60038 8.00078C6.60038 5.57073 8.57032 3.60078 11.0004 3.60078C13.4304 3.60078 15.4004 5.57073 15.4004 8.00078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7437b79f.svg";
export { ForwardRef as ReactComponent };